import { compose, withProps } from 'recompose';
import { splitEvery, splitAt } from 'ramda';
import { withTranslations } from 'js/components/hocs/withTranslations';
import { usePortletTranslations } from 'js/components/system/Portlet';

export const withCardInfo = withProps((props) => {
    const {
        displayPrizeFund = true,
        prizeFund,
        eventCountLimit,
        raceType = '',
        displayPlayerRank = true,
        rank,
        displayRegisteredToMaxPlayers = true,
        maxParticipantsCount,
        participantsCount,
        displayUsedEventsCount = true,
        registrationEndTime,
        registrationStartTime,
        eventCount = 0,
        registrationStatus,
        isWideCard,
        isMiddleCard,
        isNarrowCard
    } = props;

    const translate = usePortletTranslations();
    const t = (key, ...restArgs) => translate(`card.${key}`, ...restArgs);

    const cardInfoItems = [
        {
            label: t('prizeFund.label'),
            value: displayPrizeFund && prizeFund
        },
        {
            value: registrationEndTime && registrationStartTime,
            countDown: { endTime: registrationEndTime, startTime: registrationStartTime, status: registrationStatus }
        },
        {
            label: t('usedEvents.label'),
            value: displayUsedEventsCount && eventCountLimit && t('usedEvents.value', [eventCount, eventCountLimit, raceType])
        },
        {
            label: t('rank.label'),
            value: displayPlayerRank && rank
        },
        {
            label: t('registeredPlayers.label'),
            value: displayRegisteredToMaxPlayers
                && (maxParticipantsCount
                    ? t('registeredToMaxPlayers.value', [participantsCount, maxParticipantsCount])
                    : t('registeredPlayers.value', [participantsCount]))
        }
    ].filter(({ value }) => value);

    let cardInfoRows;

    if (isNarrowCard) {
        cardInfoRows = splitEvery(2, cardInfoItems);
    }

    if (isMiddleCard) {
        cardInfoRows = cardInfoItems.length < 4
            ? [cardInfoItems]
            : splitAt(2, cardInfoItems);
    }

    if (isWideCard) {
        cardInfoRows = cardInfoItems.length < 3
            ? splitEvery(1, cardInfoItems)
            : cardInfoItems.length === 3
                ? splitAt(1, cardInfoItems)
                : splitAt(2, cardInfoItems);
    }

    return {
        cardInfoRows
    };
});

export default compose(
    withTranslations,
    withCardInfo
);
